import { Controller } from '@hotwired/stimulus'
import '../../entrypoints/modules/semantic-ui-dropdown'
import { trans, CREATE_ISSUE_FROM } from '../../translator'

declare const $: any

export default class CreateIssueFromSubmissionController extends Controller<HTMLElement> {
  static targets = ['form', 'name', 'note', 'intro', 'categories', 'priority', 'submit', 'teams', 'status']
  static values = { typeName: String }

  declare readonly formTarget: HTMLFormElement
  declare readonly nameTarget: HTMLInputElement
  declare readonly noteTarget: HTMLTextAreaElement
  declare readonly introTarget: HTMLElement
  declare readonly categoriesTarget: HTMLSelectElement
  declare readonly priorityTarget: HTMLSelectElement
  declare readonly submitTarget: HTMLButtonElement
  declare readonly teamsTarget: HTMLSelectElement
  declare readonly statusTarget: HTMLSelectElement
  declare readonly hasStatusTarget: boolean
  declare readonly hasCategoriesTarget: boolean
  declare readonly hasPriorityTarget: boolean
  declare readonly hasSubmitTarget: boolean
  declare readonly hasNoteTarget: boolean
  declare readonly hasTeamsTarget: boolean
  declare readonly typeNameValue: string

  private priorityIsExplicit = false
  private isApplyingCategoryPriority = false

  connect (): void {
    $(this.formTarget).find('.ui.dropdown.dropdownAutomatic').dropdown({
      fullTextSearch: true,
      forceSelection: false
    })

    $(this.formTarget).find('.ui.dropdown.dropdownAutomatic-clearable').dropdown({
      fullTextSearch: true,
      clearable: true,
      forceSelection: false,
      onChange: () => {
        if (!this.isApplyingCategoryPriority) {
          this.priorityIsExplicit = true
        }
      }
    })

    this.element.addEventListener('submit', () => this.disableSubmit())
  }

  private disableSubmit (): void {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
    }
  }

  // The submissions list shares one modal instance across every row instead of rendering
  // one per row — this fills it in for whichever row's "Create Issue" action was clicked.
  bind (event: Event & { params: { actionUrl: string, name: string, label: string } }): void {
    this.reset()
    this.formTarget.setAttribute('action', event.params.actionUrl)
    this.nameTarget.value = event.params.name
    this.introTarget.textContent = trans(CREATE_ISSUE_FROM, { '%submission%': event.params.label, '%type%': this.typeNameValue }, 'forms')
  }

  reset (): void {
    this.nameTarget.value = ''
    this.noteTarget.value = ''
    this.introTarget.textContent = ''
    this.priorityIsExplicit = false
    $(this.formTarget).find('.ui.dropdown').dropdown('clear')

    if (this.hasStatusTarget && this.statusTarget.dataset.defaultValue) {
      $(this.statusTarget).dropdown('set selected', this.statusTarget.dataset.defaultValue)
    }
  }

  categoriesChanged (): void {
    if (!this.hasPriorityTarget || this.priorityIsExplicit) {
      return
    }

    let mostSevere: { priorityId: string, severity: number } | null = null

    for (const value of $(this.categoriesTarget).val() || []) {
      const option = $(this.categoriesTarget).find(`option[value="${value}"]`)
      const priorityId = option.data('issue-priority-id')
      const severity = parseInt(option.data('issue-priority-severity'))

      if (priorityId && !isNaN(severity) && (mostSevere === null || severity < mostSevere.severity)) {
        mostSevere = { priorityId, severity }
      }
    }

    if (mostSevere !== null) {
      this.isApplyingCategoryPriority = true
      $(this.priorityTarget).dropdown('set selected', mostSevere.priorityId)
      this.isApplyingCategoryPriority = false
    }
  }
}
